export default __webpack_public_path__ + "static/media/screen2.44180dad.png";